@let value = row | objectPath: column.field;
@if (column.templateComponent) {
    <ng-container #templateContainer></ng-container>
} @else if (column.isLink) {
    @if (column.click) {
        <div class="cursor-pointer text-link" (click)="column.click(row)">
            {{ value }}
            <ng-icon name="faSolidLink" />
        </div>
    } @else {
        @if (column.customRoute) {
            @let route = row[column.customRoute?.pathField] ?? column.customRoute?.path;
            @if (route) {
                <app-link
                    [permission]="row[column.customRoute?.permissionField] ?? column.customRoute.permission"
                    [route]="[route, defaultViewMode, row[column.customRoute.field]]"
                    [queryParams]="column.customRoute.queryParams ?? { meta: row?.meta }">
                    {{ value }}
                    @if (row[column.customRoute.field]) {
                        <ng-icon name="faSolidLink" />
                    }
                </app-link>
            }
        } @else {
            <app-link [checkPermission]="false" [route]="[parentRoute, defaultViewMode, row?.id]">
                {{ value }}
                @if (row?.id) {
                    <ng-icon name="faSolidLink" />
                }
            </app-link>
        }
    }
} @else if (column.click && !column.icon) {
    <app-link [checkPermission]="false" (click)="column.click(row)">
        {{ value }}
    </app-link>
} @else if (column.type === 'codelist') {
    @if (value | codelist: column.codelistName : column.hasCodelistPrefix | async; as codelist) {
        @if (fakedCodelistArray.includes(column.codelistName)) {
            {{ codelist }}
        } @else {
            @if (column.hasCodelistPrefix) {
                {{ codelist }}
            } @else {
                @if (column.codelistTooltip) {
                    @if (column.codelistPill) {
                        @if (value) {
                            <div class="flex flex-row items-end justify-between gap-2" kendoTooltip>
                                <div
                                    class="w-14 rounded-xl px-4 py-1 text-center text-xs"
                                    title="{{ codelist }}"
                                    [pill]="{ status: value, module: column.codelistName }">
                                    {{ value }}
                                </div>
                                <ng-content />
                            </div>
                        }
                    } @else {
                        <span kendoTooltip title="{{ codelist }}">
                            {{ value }}
                        </span>
                    }
                } @else {
                    @if (!value) {
                        {{ value }}
                    } @else if (column.codelistPill || column.codelistNameInPill) {
                        <div
                            class="rounded-xl px-4 py-1 text-center"
                            [pill]="{ status: value, module: column.codelistName }">
                            @if (column.codelistPill) {
                                {{ value }}
                            } @else if (column.codelistNameInPill) {
                                {{ codelist }}
                            }
                        </div>
                    } @else {
                        @if (column.codelistFull) {
                            {{ value }} - {{ codelist }}
                        } @else if (column.codelistNameOnly) {
                            {{ codelist }}
                        } @else {
                            {{ value }}
                        }
                    }
                }
            }
        }
    }
} @else if (column.type === 'select') {
    <app-select-input id="{{ value }}" [isEditMode]="false" [options]="column.options" [(value)]="row[column.field]" />
} @else if (column.type === 'boolean' && column.field === 'active') {
    <app-active [active]="value" />
} @else if (column.type === 'boolean' && !column.icon) {
    <app-boolean-input id="{{ value }}" [isDisabled]="true" [(value)]="row[column.field]" />
} @else if (column.type === 'boolean' && column.icon) {
    @if (value) {
        <ng-icon [name]="column.icon.toString()" [ngClass]="column.iconClass"></ng-icon>
    }
} @else if (column.type !== 'boolean' && column.icon) {
    <ng-container>
        {{ value }}
        <ng-icon [name]="column.icon.toString()" [ngClass]="column.iconClass" (click)="column.click(row)"></ng-icon>
    </ng-container>
} @else if (column.type === 'yesno') {
    @if (value === true) {
        <span>{{ 'Yes' | translate }}</span>
    } @else if (value === false) {
        <span>{{ 'No' | translate }}</span>
    } @else {
        <span>-</span>
    }
} @else if (column.type === 'date') {
    <span>
        <span>{{ value | customDate }}</span>
    </span>
} @else if (column.type === 'datetime') {
    <span>
        <span>{{ value | datetime }}</span>
    </span>
} @else if (column.type === 'file') {
    <app-upload-action-buttons [file]="value" [disabled]="true" />
} @else if (column.type === 'number') {
    <app-number
        [value]="value"
        [format]="
            !column.currency
                ? column.format
                : getCurrencyFormat({
                      currency: row[column.currencyField],
                      maximumFractionDigits: column.format?.maximumFractionDigits
                  })
        " />
    @if (column.appendText) {
        {{ column.appendText }}
    }
} @else if (column.type === 'flag') {
    <app-flag-icon codelist="Flag" [code]="value"></app-flag-icon>
} @else if (column.type === 'vesselType') {
    <app-vessel-type [model]="value" />
} @else if (column.type === 'seal') {
    <app-seal [model]="value" />
} @else if (column.type === 'mots') {
    <app-mean-of-transport [model]="value" />
} @else {
    @if (column.maxLength && value?.length > column.maxLength) {
        <span kendoTooltip title="{{ value }}">
            {{ value.substring(0, column.maxLength) + '...' }}
        </span>
    } @else {
        <span>
            {{ value }}
        </span>
    }
}
